/* eslint-disable */
 
/*!
 * pixi-spine - v3.1.0
 * Compiled Wed, 03 Aug 2022 17:00:10 UTC
 *
 * pixi-spine is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 * 
 * Copyright 2019-2020, Ivan Igorevich Popelyshev <ivan.popelyshev@gmail.com>, All Rights Reserved
 */
import { SpineParser } from '@pixi-spine/loader-uni';
export { Spine, SpineParser } from '@pixi-spine/loader-uni';
export * from '@pixi-spine/base';
export { SkeletonBounds } from '@pixi-spine/runtime-4.1';

SpineParser.registerLoaderPlugin();
//# sourceMappingURL=all.es.js.map
